import React, { useEffect, useRef } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from './styles'
import { connect } from 'react-redux'
import propTypes from './prop'
import Preloader from '../../components/preloader'
import ComponentBox from '../../components/component-box'
import MessageBox from '../../components/message-box'
import GlobalUploadProgress from '../../components/global-upload-progress'
import { Switch, Route } from 'react-router-dom'
import { PageNotFoundIllustration } from '../../assets'
import Menus from '../../routes'
import { withSnackbar } from 'notistack'
import translator from '../../translate'
import { snackbarDispose } from '../../reducers/snackbar/action'
import { TopBar, SideNav, AppHeader, useSideNavVisible } from './components'
import { CoursePublishProvider } from 'src/contexts/course-publish-context'
import { useLocation } from 'react-router-dom'
import clsx from 'clsx'
import { isMobile } from 'react-device-detect'
import {
  messageBoxHideAction,
  messageBoxShowAction,
} from 'src/reducers/message-box/action'
import { useVideoGalleryPopup } from 'src/hooks/useVideoGalleryPopup'
import useLeavePageWarning from 'src/hooks/useLeavePageWarning'
import { ButtonData, ButtonType, ButtonActionType } from 'src/model/button'
import DefaultCoverStyle from 'src/components/default-cover-style'
const Main = props => {
  const {
    classes,
    process,
    componentBox,
    messageBox,
    dispatch,
    snackbar,
    enqueueSnackbar,
  } = props
  const location = useLocation()
  const pathSegments = location.pathname.split('/')
  const subPage = pathSegments[pathSegments.length - 1]
  const mounted = useRef()
  const isVideoGalleryOpen = useVideoGalleryPopup()
  const showSideNav = useSideNavVisible()
  const {
    showWarning,
    handleLeave,
    handleCancel,
    handlePreventDialogs,
    hasActiveUploads,
  } = useLeavePageWarning()

  // Show message box when warning should be displayed
  useEffect(() => {
    if (showWarning) {
      const CheckboxComponent = () => {
        const [preventDialogs, setPreventDialogs] = React.useState(false)

        const handleCheckboxChange = e => {
          setPreventDialogs(e.target.checked)
          if (e.target.checked) {
            handlePreventDialogs()
          }
        }

        return (
          <div style={{ marginTop: '12px', marginBottom: '16px' }}>
            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '12px',
                color: '#666',
                cursor: 'pointer',
              }}
            >
              <input
                type="checkbox"
                checked={preventDialogs}
                onChange={handleCheckboxChange}
                style={{ marginRight: '8px' }}
              />
              Prevent this page from creating additional dialogs...
            </label>
          </div>
        )
      }

      const messageBoxContent = {
        title: 'Leave site?',
        description: 'Changes you made may not be saved.',
        component: <CheckboxComponent />,
        buttons: [
          new ButtonData(
            ButtonType.NORMAL,
            'Cancel',
            ButtonActionType.NO,
            e => {
              handleCancel()
            },
          ),
          new ButtonData(
            ButtonType.ACTION,
            'Leave',
            ButtonActionType.YES,
            e => {
              handleCancel()
              handleLeave()
            },
          ),
        ],
      }
      dispatch(messageBoxShowAction(messageBoxContent))
    }
  }, [showWarning])

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true
    } else {
      if (snackbar.messages) {
        snackbar.messages.forEach(message => {
          message.messageIds.forEach(messageId => {
            enqueueSnackbar(translator._(messageId), {
              variant: message.type,
            })
          })
          dispatch(snackbarDispose(message.id))
        })
      }
    }
  })

  const hideBackDropAction = () => {
    var elem = document.getElementById('backDrop')
    elem.style.display = 'none'

    var selectTypeWidget = document.getElementById('selectTypeWidget')
    selectTypeWidget.style.border = '1px solid #ededed'
  }

  useEffect(() => {
    dispatch(messageBoxHideAction())
  }, [location])

  const routes = (
    <Switch>
      {Menus.map((menu, index) => {
        if (menu.subMenus !== undefined) {
          return menu.subMenus.map((subMenu, index2) => {
            return (
              <Route
                key={index2 + 2000}
                exact={subMenu.default}
                path={subMenu.link}
                component={subMenu.pages}
              />
            )
          })
        } else {
          return (
            <Route
              key={index}
              exact={menu.default}
              path={menu.link}
              component={menu.pages}
            />
          )
        }
      })}
      <Route>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '80vh',
          }}
        >
          <PageNotFoundIllustration sx={{ width: 300, height: 300 }} />
          <h2
            style={{
              marginTop: 24,
              fontFamily: 'Inter',
              fontWeight: 600,
              color: '#002E47',
            }}
          >
            Page Not Found
          </h2>
        </div>
      </Route>
    </Switch>
  )

  return (
    <CoursePublishProvider>
      <DefaultCoverStyle />
    <div className={classes.root}>
      {showSideNav ? (
        <>
          <SideNav />
          <div className={classes.shellMain}>
            <AppHeader />
            <div className={classes.shellContent}>
              {/* Keyed by the top-level section (courses, collection,
                  connect…), so only switching sections replays the fade;
                  tabs inside a page don't remount it. */}
              <div
                key={location.pathname.split('/')[1] || 'home'}
                className={classes.sectionEnter}
              >
                {routes}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {subPage !== 'editor' && (
            <TopBar onOpenNav={() => {}} dispatch={dispatch} />
          )}
          <div
            className={clsx(
              subPage === 'editor'
                ? classes.editor
                : {
                    [classes.main]: !isMobile,
                    [classes.main_mobile]: isMobile,
                  },
            )}
          >
            {routes}
          </div>
        </>
      )}
      {messageBox.contents.length > 0 &&
        messageBox.contents.map((content, index) => {
          return <MessageBox content={content} id={index} key={index} />
        })}
      {process && <Preloader process={process} />}
      {componentBox.content && (
        <ComponentBox content={componentBox.content} dispatch={dispatch} />
      )}
      <div
        id="backDrop"
        className={classes.backdrop}
        onClick={() => hideBackDropAction()}
      ></div>
      <GlobalUploadProgress shouldShow={!isVideoGalleryOpen} />
    </div>
    </CoursePublishProvider>
  )
}

Main.propTypes = propTypes

const mapStateToProps = response => {
  return {
    process: response.process,
    componentBox: response.componentBox,
    messageBox: response.messageBox,
    snackbar: response.snackbar,
  }
}

export default connect(mapStateToProps)(withStyles(styles)(withSnackbar(Main)))
